import { makeStyles } from '@mui/styles';
import { styled } from '@mui/material/styles';
import type { Theme } from '@mui/material/styles';
import type { ListItemButtonProps } from '@mui/material';
import { ListItemButton } from '@mui/material';
import type { ElementType } from 'react';

export const StyledScenarioListItem = styled(ListItemButton)<ListItemButtonProps<ElementType>>(({ theme }) => ({
  borderRadius: "2.5rem",
  '&.Mui-selected': {
    backgroundColor: theme.palette.secondary[100]
  },
  '&.Mui-selected:hover': {
    backgroundColor: theme.palette.primary[100]
  },
  '&:hover': {
    backgroundColor: theme.palette.primary[100]
  },
}));

export const StyledScenarioListItemButton = styled(ListItemButton)<ListItemButtonProps<ElementType>>(({ theme }) => ({
  borderRadius: "2.5rem",
  minHeight: '3rem',
  display: 'flex',
  gap: theme.spacing(2),
  '&:hover': {
    backgroundColor: theme.palette.primary[100]
  },
}));

export default makeStyles<Theme>((theme: Theme) => ({
  root: {
    width: '100%',
    backgroundColor: '#f0f3f6'
  },
  textField: {
    width: 'calc( 100% - 24px )',
    padding: theme.spacing ? theme.spacing(0, 0, 0, 1.5) : '0px 0px 0px 12px'
  },
  margin: {
    margin: theme.spacing ? theme.spacing(1) : '8px'
  },
  withoutTBP: {
    paddingTop: 0,
    paddingBottom: 0
  },
  withB: {
    borderBottomWidth: 0,
    borderBottomColor: '#ddd',
    borderBottomStyle: 'solid'
  },
  withTBP: {
    padding: theme.spacing ? theme.spacing(0.8, 2, 0.8, 0.8) : '6px 16px 6px 6px'
  },
  iconMWidth24: {
    minWidth: 24
  },
  paddingRight10: {
    paddingRight: 10
  },
  '&.Mui-selected': {
    backgroundColor: theme.palette.secondary[100]
  },
  selected: {
    backgroundColor: theme.palette.secondary[100]
  },
  selectedIcon: {
    color: '#4071b0'
  },
  white: {
    color: 'white'
  },
  black: {
    color: 'black'
  },
  subMenuWidth: {
    minWidth: 44
  },
  subGroupSubMenuWidth: {
    minWidth: 64
  },
  inputClasses: {
    '&:before': {
      borderBottomColor: '#ffffffa0'
    },
    '&&&:hover:before': {
      borderBottomColor: '#ffffff'
    }
  },
  colapsedEntered: {
    backgroundColor: theme.palette.grey[50],
    borderRadius: "0.5rem",
  },
  listSection: {
    backgroundColor: 'inherit'
  },
  ul: {
    backgroundColor: 'inherit',
    padding: 0
  },
  subHeader: {
    backgroundColor: theme.palette.secondary.main,
    color: 'white'
  },
  nested: {
    paddingLeft: theme.spacing ? theme.spacing(2) : '16px',
    backgroundColor: 'rgba(255, 255, 255, 0.1)'
  },
  switchLight: {
    justifyContent: 'flex-start'
  },
  sharedScenario: {
    color: theme.palette.primary[700]
  },
  folderItem: {
    backgroundColor: 'transparent'
  },
  rootItem: {
    backgroundColor: 'rgba(255, 255, 255, 0.05)'
  }
}));
